import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { ViewMode } from '../../new-order-item-custom-qty-date.component';

@Component({
    selector: 'app-new-order-item-accordion-list',
    templateUrl: './new-order-item-accordion-list.component.html',
    styleUrls: ['./new-order-item-accordion-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewOrderItemAccordionListComponent {

  @Input() orderItemsFormCustomDate: FormArray;
  @Input() supportsSplitDelivery: boolean;
  @Input() showStockQty: boolean;
  @Input() maxStoreCustomDate: string;
  @Input() viewMode: ViewMode;
  @Input() itemsSelected: number[] = [];
  @Input() minBulkDate: string;
  @Input() componentId: string;
  @Input() expandCollapse$: Subject<'expand' | 'collapse'>;

  @Output() dateAdded = new EventEmitter<{ orderItemIndex: number; customDate?: string }>();
  @Output() stockDateAdded = new EventEmitter<number>();
  @Output() customDateCleared = new EventEmitter<number>();
  @Output() dateRemoved = new EventEmitter<{ orderItemIndex: number; customDateIndex: number }>();
  @Output() dateTimeChanged = new EventEmitter<{ ev: string; form: AbstractControl }>();
}
